export default function Footer() {
    return <>
   
   <nav className="navbar navbar-success">
  <div className="container-fluid">
    <span className="navbar-text">
      FootprintFinder
    </span>
  </div>
</nav>
</>
}